import React from 'react';
import { Shield } from 'lucide-react';

export function SecurityScoreWidget() {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Security Score</h3>
        <Shield className="h-5 w-5 text-gray-500" />
      </div>
      <div className="space-y-2">
        <p className="text-sm text-gray-500 dark:text-gray-400">Security score not available</p>
      </div>
    </div>
  );
}